export const environment = {
  production: false,
  apiUrl: 'https://api-mono-dev.munily.xyz',
  munilyApiUrl: 'https://api-dev.munily.xyz',//Old Api
  envDeployed: 'dev',
  amplitude: {
    apiKey: '46c912ce0505f555a0cfc2682c2a2641'
  },
  storeUrls: {
    playStorePei: 'https://play.google.com/store/apps/details?id=com.adp.peiam',
    appStorePei: 'https://apps.apple.com/us/app/pei-am/id1587648598'
  }
};
